import React from "react";
import Form from "../form/multi-step";
import { ReactComponent as FiveStars } from "assets/svgs/five-stars.svg";
import { Swiper, SwiperSlide } from "components/swiper";
import { Navigation, Mousewheel, Autoplay } from "swiper/modules";
import Image from "components/image";
import { useMediaQuery } from "react-responsive";
import { SCREEN_SIZES } from "utils/constants";

const MultiStepFormLayout = ({ data }) => {
	const { title, subtitle, showCompactView = false, partnerLogos = [], bgImage, mobileBgImage, tag } = data;

	const swiperSettings = {
		modules: [Navigation, Mousewheel, Autoplay],
		loop: partnerLogos.length > 3,
		speed: 3000,
		mousewheel: { enabled: true, forceToAxis: true },
		autoplay: { delay: 0, disableOnInteraction: false },
		breakpoints: {
			320: { slidesPerView: 3 },
			680: { slidesPerView: 3 },
			992: { slidesPerView: partnerLogos.length > 4 && 5 },
		},
	};

	const isMobile = useMediaQuery({ maxWidth: SCREEN_SIZES.sm });

	const background = bgImage && {
		backgroundImage: `url(${isMobile ? mobileBgImage : bgImage})`,
		backgroundRepeat: "no-repeat",
		backgroundSize: "cover",
		backgroundPosition: "center",
	};

	return (
		<div id="modThreeStepsForm" style={background} >
			<div className="container-fluid-padding py-8">
				<div className="flex gap-12 lg:gap-10 flex-col md:flex-row">
					{!showCompactView ?
						<div className="flex flex-col my-auto gap-6 md:w-1/2">
							<div className="flex flex-col my-auto gap-6">
								{title && <h2 className=" text-[28px] md:text-3xl lg:text-4xl xl:text-h2 font-base font-bold">{title}</h2>}
								{subtitle && <p className="text-lg">{subtitle}</p>}
							</div>
							<div className="flex flex-col my-auto gap-4">
								<div className="flex flex-col">
									<div className="flex gap-1 items-center">
										<p className="font-medium text-xl">4.9</p>
										<FiveStars />
									</div>
									<p className="text-secondary">Average rating for this year</p>
								</div>
							</div>
							<div className="w-full flex">
								<Swiper {...swiperSettings} className="flex w-full overflow-auto no-scrollbar">
									{partnerLogos.map((item, index) => (
										<SwiperSlide key={index} className="flex justify-center px-2 mx-auto !w-1/3 lg:!w-1/4">
											<Image image={item} className="m-auto" />
										</SwiperSlide>
									))}
								</Swiper>
							</div>
						</div>
						:
						<div className="flex flex-col mb-auto pt-2 gap-6 md:w-1/2 lg:pr-14">
							{title && <h3 className="font-base font-bold md:text-[40px]">{title}</h3>}
							{subtitle && <p className="text-lg text-secondary">{subtitle}</p>}
						</div>
					}
					<div className="flex md:w-1/2 flex-col lg:flex-row">
						<div className="px-4 py-8 lg:p-10 flex bg-cream w-full">
							<Form tag={tag} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MultiStepFormLayout;